<template>
  <span>
    <button @click="$emit('toggleOn')" type="button" class="w3-button w3-text-theme"><i class="far fa-times-circle"></i>  Remove</button> 
  </span>
</template>

<script>
  import RemoveButton from './RemoveButton.ts'
  export default RemoveButton
</script>
